import { currencyOptions } from "../data/invoiceDefaults";
import { Field, FormSection, SelectField, TextAreaField } from "./FormControls";
import LineItemsEditor from "./LineItemsEditor";

export default function InvoiceForm({
  invoice,
  validationMessages,
  onUpdateClient,
  onUpdateInfo,
  onRegenerateInvoiceNumber,
  onUpdateCurrency,
  onUpdateTerms,
  onAddItem,
  onRemoveItem,
  onUpdateItem,
}) {
  return (
    <form className="invoice-form" onSubmit={(event) => event.preventDefault()}>
      {validationMessages.length ? (
        <div className="validation-panel" role="alert">
          <strong>Review required fields</strong>
          <ul>
            {validationMessages.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </div>
      ) : null}

      <FormSection title="Client details">
        <Field
          id="client-name"
          label="Client or company name"
          value={invoice.client.name}
          required
          onChange={(value) => onUpdateClient("name", value)}
        />
        <TextAreaField
          id="billing-address"
          label="Billing address"
          value={invoice.client.address}
          onChange={(value) => onUpdateClient("address", value)}
        />
        <Field
          id="client-phone"
          label="Phone number"
          value={invoice.client.phone}
          onChange={(value) => onUpdateClient("phone", value)}
        />
        <Field
          id="client-email"
          label="Email address"
          type="email"
          value={invoice.client.email}
          onChange={(value) => onUpdateClient("email", value)}
        />
        <Field
          id="volume-weight"
          label="Volume or weight"
          value={invoice.client.volumeWeight}
          onChange={(value) => onUpdateClient("volumeWeight", value)}
        />
        <Field
          id="client-reference"
          label="Additional client reference"
          value={invoice.client.reference}
          onChange={(value) => onUpdateClient("reference", value)}
        />
      </FormSection>

      <FormSection title="Invoice information">
        <Field
          id="invoice-number"
          label="Invoice number"
          value={invoice.info.invoiceNumber}
          required
          onChange={(value) => onUpdateInfo("invoiceNumber", value)}
        />
        <div className="form-field invoice-number-action">
          <span>&nbsp;</span>
          <button className="button button-secondary" type="button" onClick={onRegenerateInvoiceNumber}>
            Generate new number
          </button>
        </div>
        <Field
          id="issue-date"
          label="Issue date"
          type="date"
          value={invoice.info.issueDate}
          required
          onChange={(value) => onUpdateInfo("issueDate", value)}
        />
        <SelectField
          id="currency-code"
          label="Currency"
          value={invoice.info.currencyCode}
          required
          options={currencyOptions.map((currency) => ({
            value: currency.code,
            label: currency.label,
          }))}
          onChange={onUpdateCurrency}
        />
      </FormSection>

      <LineItemsEditor
        items={invoice.items}
        currencySymbol={invoice.info.currencySymbol}
        onAddItem={onAddItem}
        onRemoveItem={onRemoveItem}
        onUpdateItem={onUpdateItem}
      />

      <FormSection title="Terms">
        <TextAreaField
          id="term-currency"
          label="Currency"
          value={invoice.terms.currency}
          rows={3}
          onChange={(value) => onUpdateTerms("currency", value)}
        />
        <TextAreaField
          id="term-payment"
          label="Payment"
          value={invoice.terms.payment}
          rows={4}
          onChange={(value) => onUpdateTerms("payment", value)}
        />
      </FormSection>
    </form>
  );
}
